export default __webpack_public_path__ + "static/media/ru.63607c05.svg";